import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

// Styles
const s = require('./ModalBottomBar.css');

// Props
interface IModalBottomBarProps {
    className?: string;
    classNameForWrapper?: string;
    classNameForContent?: string;
    show?: boolean;
}

// Component
@observer
export class ModalBottomBar extends React.Component<IModalBottomBarProps, {}> {
    static get defaultProps(): IModalBottomBarProps {
        return {
            className: undefined,
            classNameForWrapper: undefined,
            classNameForContent: undefined,
            show: true,
        };
    }

    public render() {
        return (
            <div
                className={classNames(s.container, this.props.className, {
                    [s.show]: this.props.show,
                })}
                style={{
                    pointerEvents: this.props.show ? undefined : 'none',
                }}
            >
                <div
                    className={classNames(
                        s.wrapper,
                        this.props.classNameForWrapper
                    )}
                >
                    <div
                        className={classNames(
                            s.content,
                            this.props.classNameForContent
                        )}
                    >
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/content/ModalBottomBar.tsx